var _style, _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 260 260",
    style: {
      enableBackground: "new 0 0 260 260"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M63.5,131c-5-39.6,17-62.9,36.2-75.4c13.2-8.6,29.3-13,46.8-12.8c47.7,0.4,85.7,38,86.5,85.6 c0.5,28.6-12.8,55.3-35.3,71.7c18-20.7,25.6-46.6,22.1-75.2c-2-16.1-9.4-31.7-20.2-43.1c-12.3-12.8-28.3-19.5-46.1-19.2 c-36.1,0.5-65,30.5-64.4,66.8c0.1,2.7,0.8,9.2,0.8,9.2h1.6c10.3,0,18.9-7.7,20.4-18v-0.1c3.5-20.7,20.8-36.7,41.9-37 c25.2-0.4,41.1,21.7,43.9,43.8c5,40-17,63.4-36.2,76.1c-13.1,8.6-29.3,13.1-46.8,12.8C67,215.7,29,177.8,28.2,129.9 C27.7,100,42.4,71.8,66.4,55.5c-20.2,21.1-28.8,47.8-25,77.8c2,16,9.4,31.5,20.2,42.7c12.3,12.8,28.3,19.3,46.1,19.1 c36.1-0.5,65-30.2,64.4-66.2c0-1.4-0.3-5.6-0.3-5.6h-2.2c-10.1,0-18.7,7.1-20.8,16.9v0.1c-1.8,7.7-5.5,14.8-11.1,20.7 c-8.1,8.5-18.8,13.3-30.3,13.4c-0.3,0-0.4,0-0.7,0C81.9,174.4,66.1,152.7,63.5,131 M94.7,22.5C83.3,24.9,72.4,29,62.3,34.7 c-7.6,4-14.5,8.7-20.9,14.2C18,68.9,5.1,96.8,5.1,127.5c0,18.8,4.8,36.8,13.9,52.7c14.1,26.2,38.8,45.8,68.5,53.4 c13.5,4.2,28.1,6.5,43.2,6.5c34.1,0,65.6-11.7,88.7-32.8c2.7-2.4,5.2-5,7.6-7.6c17.6-19.2,28.6-44.2,28.1-71.4 c0-0.9-0.1-1.8-0.1-2.8c-0.6-62.1-52.7-107-124.3-107C118.2,18.3,106.1,19.7,94.7,22.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -148.913,
    y1: 55.0589,
    x2: -145.9026,
    y2: 55.0589,
    gradientTransform: "matrix(83.0143 0 0 83.0143 12367.1514 -4441.5347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80C41C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0870117,
    style: {
      stopColor: "#7BC125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2339,
    style: {
      stopColor: "#6DBB3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4226,
    style: {
      stopColor: "#57B25C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6459,
    style: {
      stopColor: "#39A784"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8956,
    style: {
      stopColor: "#169CAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0397BE"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 18.3,
    className: "st0",
    width: 250.3,
    height: 221.6
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logoOnly.24fb4edbc362a79fdfa8278555723f26.svg";
export { ForwardRef as ReactComponent };